import { useState, useEffect } from "react";
import Modal from "./Modal";

function ModalCard({
  visible,
  dynamicTitle,
  onHide,
  actions,
  dynamicContent,
  activeDynamicContent,
  colorActive,
  defaultIndexColorActive
}) {
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (defaultIndexColorActive !== null && visible) {
      setSelected(defaultIndexColorActive);
    }
  }, [defaultIndexColorActive, visible]);
  return (
    <Modal
      visible={visible}
      dynamicTitle={dynamicTitle}
      onHide={() => {
        onHide();

      }}

      closable={true}
    >
      <div className={`row text-center justify-content-around p-2`}>
        {actions?.map((a, index) => (
          <div id={index} key={index} className={`${a.col}`}>
            <div
              onClick={() => { a.action(); setSelected(index); }}
              className={`card card-animation d-flex align-items-center p-5 h-100 ${colorActive && selected === index && "bg-success text-white"}`}
              style={{ borderRadius: "15px" }}
            >
              <div className="my-auto">
                <h1 style={{ fontSize: "50px" }}>
                  <i className={`fa-solid ${a.icon}`}></i>
                </h1>
                <h2>{a.title}</h2>
              </div>
            </div>
          </div>
        ))}
      </div>
      {activeDynamicContent && dynamicContent && (dynamicContent)}
    </Modal >
  );
}

export default ModalCard;
